import lodash from 'lodash'

import { formatDecimalNumber } from '../../utils/format'

export function formatDecimal(
  value: number | string,
  minimumFractionDigits = 2,
): string {
  // console.log('formatDecimal', value)
  const n = parseFloat(String(value))
  // console.log('n', n)
  if (lodash.isNaN(n)) {
    return ''
  }
  // console.log('formatting n', n)
  const result = formatDecimalNumber(
    n,
    minimumFractionDigits,
    minimumFractionDigits,
  )
  // console.log('formatDecimal', { value, result })
  return result
}
